import React from "react";
import { Space } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import {
  HeaderContainer,
  BackButton,
  HeaderContent,
  HeaderTop,
  PageTitle,
  PageSubtitle,
  FiltersContainer,
  FilterLabel,
} from "./styles";
import { ProfitHeaderProps } from "./types";
import CustomersDropDown from "../../Loyalty/CustomersDropdown";
import StoresDropDown from "../StoresDropDown";

const ProfitHeader: React.FC<ProfitHeaderProps> = ({
  merchant,
  storeId,
  user,
  onMerchantChange,
  onStoreChange,
}) => {
  const navigate = useNavigate();

  return (
    <HeaderContainer>
      <BackButton
        type="text"
        icon={<FontAwesomeIcon icon={faArrowLeft} />}
        onClick={() => navigate(-1)}
        aria-label="Go Back to Analytics Dashboard"
      />
      <HeaderContent>
        <HeaderTop>
          <PageTitle level={2}>Profit Margins</PageTitle>
          <FiltersContainer>
            {user.role === "admin" && (
              <Space>
                <FilterLabel>By Merchants</FilterLabel>
                <CustomersDropDown onOptionSelect={(merch) => {
                    onMerchantChange(merch);
                  }}
                />
              </Space>
            )}
            <Space>
              <FilterLabel>By Store</FilterLabel>
              <StoresDropDown
                onOptionSelect={(store) => {
                  onStoreChange(store);
                }}
                merchantId={merchant?.id}
                role={user?.role}
              />
            </Space>
          </FiltersContainer>
        </HeaderTop>
        <PageSubtitle>Analyze profit margins and cost analysis</PageSubtitle>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default ProfitHeader;
